/**
 * Gestaltung der Planungszentrale nach dem Skill `musikonzept-design`
 * (docs/design/musikonzept-design/SKILL.md): ruhige Karten, Teal und Orange als Akzente.
 *
 * Bewusst LOKAL mit festen Werten: src/index.css, die Farbvariablen und
 * tailwind.config.ts bleiben unverändert. Alle Klassen stehen als vollständige
 * Zeichenketten da, damit Tailwind sie findet.
 */

export const FOKUS =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#227277] focus-visible:ring-offset-2";

export const SCHATTEN = "shadow-[0_1px_2px_rgba(29,41,52,.06),0_6px_18px_rgba(29,41,52,.06)]";

/** Weiße Karte ohne Rahmen, Rundung 16px (in der Spalte etwas kleiner: 12px). */
export const KARTE = `rounded-xl bg-white ${SCHATTEN} dark:bg-card`;
export const KARTE_KLICKBAR = `${KARTE} transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_12px_28px_rgba(29,41,52,.12)]`;

/** Spalte als ruhige Fläche (Stein), keine eigene Farbe je Spalte. */
export const SPALTE = "rounded-[20px] bg-[#F2F0EA] dark:bg-muted/30";

export const DACHZEILE = "text-[12px] font-bold uppercase leading-4 tracking-[0.08em] text-[#227277]";
export const TITEL_SEITE =
  "font-display text-[24px] font-extrabold leading-[28px] tracking-[-0.02em] text-[#1D2934] dark:text-foreground sm:text-[28px] sm:leading-8";
export const TITEL_SPALTE = "font-display text-[14px] font-bold leading-5 text-[#1D2934] dark:text-foreground";
export const TITEL_KARTE = "text-[14px] font-semibold leading-5 text-[#1D2934] dark:text-foreground";
export const TEXT_LEISE = "text-[13px] leading-[18px] text-[#4E6274] dark:text-muted-foreground";

export const HAUPTKNOPF = `inline-flex min-h-11 items-center justify-center gap-2 rounded-full bg-[#227277] px-5 text-[15px] font-semibold text-white transition-colors hover:bg-[#1B5E62] disabled:opacity-60 ${FOKUS}`;
export const LEISER_KNOPF = `inline-flex min-h-9 items-center justify-center gap-1.5 rounded-full px-3 text-[14px] font-semibold text-[#227277] transition-colors hover:bg-[#E6F4F4] disabled:opacity-60 ${FOKUS}`;

/** Fälligkeits-Chip: rot = überfällig, orange = heute/diese Woche, grau = später. */
export const CHIP_FAELLIG: Record<"ueberfaellig" | "heute" | "woche" | "spaeter", string> = {
  ueberfaellig: "bg-[#FDECEA] text-[#B42318]",
  heute: "bg-[#FDF1DE] text-[#9A5B00]",
  woche: "bg-[#FDF1DE] text-[#9A5B00]",
  spaeter: "bg-[#F2F0EA] text-[#4E6274]",
};

/**
 * Farbe des schmalen Streifens links an der Karte, je Bereich. Nur Farben aus dem
 * Designsystem; unbekannte Bereiche bekommen das neutrale Grau.
 */
export const BEREICH_FARBE: Record<string, string> = {
  Allgemein: "#C5CFCE",
  Ausbildung: "#F5A623",
  Lernplattform: "#49BDC2",
  Webinare: "#EFC155",
  Marketing: "#9A5B00",
  Technik: "#227277",
  Design: "#139980",
  Termine: "#4E6274",
};

export function bereichFarbe(bereich: string | null | undefined): string {
  return BEREICH_FARBE[bereich || "Allgemein"] ?? BEREICH_FARBE.Allgemein;
}

/** Farbe des Avatars (Initialen): teal-nebel mit teal-tief, für mich selbst teal-tief mit Weiß. */
export const AVATAR = "bg-[#E6F4F4] text-[#227277]";
export const AVATAR_ICH = "bg-[#227277] text-white";
